import styled, { css } from 'styled-components'
import { theme } from 'global'

interface ITrack {
  vertical: boolean
  width?: string
  height?: string
}

export const SliderTrack = styled.div<ITrack>`
  ${({ vertical, width, height }) =>
    css`
      /* prevent page scroll when touching slider track */
      user-select: none;
      touch-action: none;
      position: relative;
      border-radius: 30px;
      border: 3px solid ${theme.colors.white};
      background: transparent;
      ${vertical &&
        css`
          height: ${height || '240px'};
          width: ${width || '40px'};
        `}
      ${!vertical &&
        css`
          height: ${height || '60px'};
          width: ${width || '100%'};
        `}
    `}
`
